import keyMirror from 'keymirror'

export default keyMirror({
  GET_SYSTEM_FIRMWARE_CATEGORIES_REQUEST: null,
  GET_SYSTEM_FIRMWARE_CATEGORIES_SUCCESS: null,
  GET_SYSTEM_FIRMWARE_CATEGORIES_FAILED: null
})
